import { render, staticRenderFns } from "./homeMYOrder.vue?vue&type=template&id=6e8eb880&scoped=true"
import script from "./homeMYOrder.vue?vue&type=script&lang=js"
export * from "./homeMYOrder.vue?vue&type=script&lang=js"
import style0 from "./homeMYOrder.vue?vue&type=style&index=0&id=6e8eb880&prod&lang=less&scoped=true"
import style1 from "./homeMYOrder.vue?vue&type=style&index=1&id=6e8eb880&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8eb880",
  null
  
)

export default component.exports